module.exports = __webpack_public_path__ + "static/media/newsDetailPicture.4d4b7071.png";